import FamlyTheme from './new-look';
// Twizzle Tops uses the Famly theme
export const TwizzleTopsTheme = {
    ...FamlyTheme,
    title: 'Twizzle Tops',
};
